import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../../hook/userAuth";
import { Navigate, Link, useNavigate } from "react-router-dom";
import HeaderPage from "../../../components/HeaderPage/HeaderPage";
import ModalBasic from "../../../components/ModalBasic/ModalBasic";
import { useLocation } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { Loader } from "semantic-ui-react";
import { TableCalificacionesCurso } from "../../../components/GestionAcademica/TableCursos/CalificacionesCurso/TableCalificacionesCurso";
import FormRegularizaciones from "../../../components/GestionAcademica/TableCursos/CalificacionesCurso/FormRegularizaciones";
import Swal from "sweetalert2";
import { ListaAlumnosFaltantes } from "../../../components/GestionAcademica/TableCursos/AlumnosFaltantes/ListaAlumnosFaltantes";
import { ListaAlumnosTraslado } from "../../../components/GestionAcademica/TableCursos/AlumnosTraslado/ListaAlumnosTraslado";
import FormRegistroCalificaciones from "../../../components/GestionAcademica/TableCursos/FormRegistroCalificaciones";

function AlumnosCurso() {
  const { auth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  let datosCurso = location.state?.datosCurso;
  let alumnoId = location.state?.alumnoId;

  // Si no hay datos en location.state, intentar obtenerlos de location.search
  if (!datosCurso) {
    const queryParams = new URLSearchParams(location.search);
    datosCurso = JSON.parse(queryParams.get("datosCurso"));
    alumnoId = JSON.parse(queryParams.get("alumnoId"));
  }

  useEffect(() => {
    if (!datosCurso) {
      navigate("/cursos");
    }
  }, [datosCurso, navigate]);

  if (!auth?.me?.es_personal_control_escolar) {
    return <Navigate to={"/"} />;
  }

  return datosCurso ? (
    <LogicaAlumnosCurso datosCurso={datosCurso} alumnoId={alumnoId} />
  ) : null;
}
function LogicaAlumnosCurso({ datosCurso, alumnoId }) {
  const alumnoSeleccionado = alumnoId;
  const { first_name, last_name, apellido_materno } =
    datosCurso.user_data || {};
  const { nombre_materia, clave_materia, semestre, numero_unidades } =
    datosCurso.materia_data;
  const { numero_grupo } = datosCurso.grupo_data;
  const { auth } = useAuth();
  const [refetch, setRefetch] = useState(false);
  const [alumnosCalificaciones, setAlumnosCalificaciones] = useState(null);
  const [ids_alumnosCali, setIdsAlumnosCali] = useState(null);
  const [ids_alumnosTraslado, setIdsAlumnosTraslado] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [alumnosFaltantes, setAlumnosFaltantes] = useState([]);
  const [alumnosTraslado, setAlumnosTraslado] = useState([]);

  const openCloseModal = () => setShowModal((prev) => !prev);

  async function getAlumnosCali() {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_API}/api/calificacion_curso/?curso=${datosCurso.id}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      const result = response.data;
      setLoading(false);
      setAlumnosCalificaciones(result);
      const idsAlumnos = result.map((cursoCali) => cursoCali.alumno);
      setIdsAlumnosCali(idsAlumnos);
      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  async function getAlumnosTraslado() {
    try {
      const response = await axios.get(
        `${BASE_API}/api/alumno/?alumno_traslado=true`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      const result = response.data;
      setAlumnosTraslado(result);
      const idsAlumnosTraslado = result.map((alumno) => alumno.id);
      setIdsAlumnosTraslado(idsAlumnosTraslado);
      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getAlumnosCali();
    // eslint-disable-next-line
  }, [refetch]);

  useEffect(() => {
    getAlumnosTraslado();
    // eslint-disable-next-line
  }, [refetch]);

  useEffect(() => {
    if (ids_alumnosCali && datosCurso.grupo_data.alumnos) {
      const alumnosGrupo = datosCurso.grupo_data.alumnos;
      const alumnosFaltantes = alumnosGrupo.filter(
        (alumno) => !ids_alumnosCali.includes(alumno)
      );
      setAlumnosFaltantes(alumnosFaltantes);
    }
  }, [ids_alumnosCali, datosCurso.grupo_data.alumnos]);

  useEffect(() => {
    if (ids_alumnosTraslado && ids_alumnosCali) {
      const alumnosFaltantesTraslado = ids_alumnosTraslado.filter(
        (id) => !ids_alumnosCali.includes(id)
      );
      setAlumnosTraslado(alumnosFaltantesTraslado);
    }
  }, [ids_alumnosTraslado, ids_alumnosCali]);

  const onRefetch = () => {
    setRefetch((prev) => !prev);
  };

  const addAlumnosCurso = () => {
    setTitleModal("Añadir alumnos faltantes");
    setContentModal(
      <ListaAlumnosFaltantes
        onClose={openCloseModal}
        onRefetch={onRefetch}
        id_curso={datosCurso.id}
        ids_alumnosFaltantes={alumnosFaltantes}
      />
    );
    openCloseModal();
  };

  const addAlumnosTrasladoCurso = () => {
    setTitleModal("Añadir alumnos de traslado");
    setContentModal(
      <ListaAlumnosTraslado
        onClose={openCloseModal}
        onRefetch={onRefetch}
        id_curso={datosCurso.id}
        ids_alumnosFaltantes={alumnosTraslado}
      />
    );
    openCloseModal();
  };

  async function bajaCursoAlumno(data) {
    const confirmMessage = `<div>¿Estás seguro de que deseas dar de baja al alumno con número de matrícula ${
      data.alumno_data.matricula || data.alumno_data.curp
    } del curso? </div>
    <div style="color: red;">Nota: Ten en cuenta que, en caso de tener calificaciones en este curso, estas serán eliminadas. Esta acción no puede deshacerse.<div>`;

    const result = await Swal.fire({
      html: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      confirmButtonColor: "#2f6d02",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#920804",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${BASE_API}/api/calificacion_curso/${data.id}/`,
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        );
        const result = response.data;
        onRefetch();
        return result;
      } catch (error) {
        console.log(error);
        window.location.reload();
        window.location.href = "/Login";
        throw error;
      }
    }
  }

  const formRegular = (data) => {
    setTitleModal("Asignación de calificaciones y fechas de regularización");
    setContentModal(
      <FormRegularizaciones
        onClose={openCloseModal}
        onRefetch={onRefetch}
        cursoCali={data}
      />
    );
    openCloseModal();
  };

  const formSubirCalificaciones = (data) => {
    setTitleModal("Asignación de calificaciones");
    setContentModal(
      <FormRegistroCalificaciones
        onClose={openCloseModal}
        onRefetch={onRefetch}
        cursoCali={data}
      />
    );
    openCloseModal();
  };

  const formatPeriodo = (fecha) => {
    const opciones = { month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    return fechaFormateada;
  };

  return (
    <div>
      {datosCurso.materia_data.es_de_titulacion ? (
        <h1 className="encabezado">MATERIA DE TITULACION</h1>
      ) : (
        <h1 className="encabezado">
          CATEDRÁTICO:{" "}
          {datosCurso.user_data
            ? `${first_name} ${last_name} ${apellido_materno}`
            : "PENDIENTE POR ASIGNAR"}
        </h1>
      )}
      <h1 className="encabezado">
        CURSO: <span className="nombreM">{nombre_materia} </span>{" "}
        <span> {clave_materia} </span>
      </h1>

      <h1 className="encabezado">
        GRUPO: {numero_grupo} <span> SEMESTRE: {semestre} </span> TURNO: M{" "}
        <span>
          {" "}
          PERIODO: {formatPeriodo(datosCurso.periodo_data.fecha_inicio)} -{" "}
          {formatPeriodo(datosCurso.periodo_data.fecha_fin)}
        </span>
      </h1>

      <h1 className="tituloin2"> </h1>

      <h6 className="sub">
        <Link to="/cursos">Cursos </Link>/ Grupo {numero_grupo}
      </h6>
      <div style={{ display: "flex" }}>
        <HeaderPage btnTitulo="Alumnos faltantes" btnClick={addAlumnosCurso} />
        <HeaderPage btnTitulo="Traslados" btnClick={addAlumnosTrasladoCurso} />
      </div>
      {loading ? (
        <Loader active inline="centered">
          Cargando....
        </Loader>
      ) : (
        <TableCalificacionesCurso
          alumno_id={alumnoSeleccionado}
          alumnosCali={alumnosCalificaciones}
          numero_unidades={numero_unidades}
          bajaCursoAlumno={bajaCursoAlumno}
          regularizacion={formRegular}
          asignarCalificacion={formSubirCalificaciones}
          es_materia_titulacion={datosCurso}
        />
      )}
      <ModalBasic
        show={showModal}
        title={titleModal}
        children={contentModal}
        close={openCloseModal}
      />
    </div>
  );
}

export default AlumnosCurso;
